import axios from 'axios'
import BaseAPI from './base/base-api'

/**
 * Đầu api để gọi vào controller: TaxReturnRegisController
 */
class TaxRegisAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'DeclareAPI';
    controllerName = 'taxreturnregis';
}

export default new TaxRegisAPI();